import React, { useEffect } from 'react';
import { LxModuleView } from '@utils/siteLx';

import { LX_RESUME_EDIT_MODULE_VIEW } from '@common/const';

/**
 * LX_MV事件打点
 *
 * @param WrappedComponent
 * @returns
 */

export default function ModuleView(WrappedComponent, name) {
  function NewModuleView(props) {
    let { type } = props || {};
    const campusType = ['skillStandard', 'paper', 'competition'];
    const socialType = ['patent', 'exam', 'socialAccount', 'selfDescription'];
    if (campusType.find((item) => item === name)) type = 'campus';
    else if (socialType.find((item) => item === name)) type = 'social';
    useEffect(() => LxModuleView({ bid: LX_RESUME_EDIT_MODULE_VIEW[name], valLab: { resumeType: type } }), []);
    return <WrappedComponent {...props} />;
  }
  return NewModuleView;
}
